import React from 'react';
import Routers from './Routers';
import { Provider } from 'react-redux';
import { store } from '../src/config/store';

class App extends React.Component {
  render() {
    return (
      <Provider store={store} >
        <Routers />
      </Provider>
    );
  }
}

export default App;
